// extracted by mini-css-extract-plugin
export default {"doors":"doors_doors__KAnX9","containerIMG":"doors_containerIMG__Uxx2r","wrapper":"doors_wrapper__WmPjB","container":"doors_container__Ctjoi"};